import { Notice, SecondaryButton } from './ui'

export function VoiceReferenceNotice({ status, onRecord }: { status?: string; onRecord: () => void }) {
  if (!['synthetic_preview', 'rerecord_required', 'unavailable'].includes(status ?? '')) return null
  return <section className="server-consent-panel" aria-label="목소리 다시 등록 안내">
    <Notice tone="warning">{status === 'rerecord_required' ? '새 변환 방식에서 이전 목소리 자료를 사용할 수 없어요. 부모님 목소리를 다시 녹음해 주세요.' : status === 'synthetic_preview' ? '이 목소리는 원본 녹음이 없어 합성 미리듣기만 남아 있어요. 실제 부모 목소리로 변환하려면 다시 녹음해 주세요.' : '변환에 사용할 원본 녹음을 찾지 못했어요. 목소리를 다시 등록해 주세요.'}</Notice>
    <p>새 목소리를 승인할 때까지 이전 목소리와 이미 완성된 동화는 그대로 남아요.</p>
    <SecondaryButton onClick={onRecord}>내 목소리 다시 녹음하기</SecondaryButton>
  </section>
}
